/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Partnerships_DescriptionInputs */

const en_directory_resources_partnerships_description = /** @type {(inputs: Directory_Resources_Partnerships_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work with Seek AI on relevant product discovery, creator programs, and community campaigns.`)
};

const zh_directory_resources_partnerships_description = /** @type {(inputs: Directory_Resources_Partnerships_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可与 Seek AI 围绕产品发现、创作者计划和社区活动展开合作。`)
};

/**
* | output |
* | --- |
* | "Work with Seek AI on relevant product discovery, creator programs, and community campaigns." |
*
* @param {Directory_Resources_Partnerships_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_partnerships_description = /** @type {((inputs?: Directory_Resources_Partnerships_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Partnerships_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_partnerships_description(inputs)
	return zh_directory_resources_partnerships_description(inputs)
});
export { directory_resources_partnerships_description as "directory.resources.partnerships.description" }